// extracted by mini-css-extract-plugin
module.exports = {"PurchaseCloseModalAlert":"PurchaseCloseModalAlert_PurchaseCloseModalAlert__27LV7","PurchaseCloseModalAlert__Text":"PurchaseCloseModalAlert_PurchaseCloseModalAlert__Text__3Bh5E"};